var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "b-card-actions",
        {
          attrs: {
            "show-loading": _vm.fetching,
            "action-collapse": "",
            title: "Notas fiscais recebidas pendentes",
          },
        },
        [
          _c(
            "b-alert",
            {
              staticClass: "mb-1",
              attrs: { show: _vm.hasError, variant: "danger" },
            },
            [
              _c("div", { staticClass: "alert-body" }, [
                _vm._v(
                  " " +
                    _vm._s(
                      _vm.$t(
                        "Não foi possível carregar as notas fiscais recebidas pendentes"
                      )
                    ) +
                    " "
                ),
              ]),
            ]
          ),
          !_vm.hasError
            ? _c("b-table", {
                ref: "pending-received-invoices-table",
                staticClass: "bordered",
                attrs: {
                  "show-empty": "",
                  responsive: "",
                  striped: "",
                  "no-local-sorting": "",
                  "empty-text": _vm.$t("Sem notas fiscais recebidas pendentes"),
                  fields: _vm.fields,
                  items: _vm.summaries,
                  "sort-by": _vm.sorting.sortBy,
                  "sort-desc": _vm.sorting.sortDesc,
                },
                on: {
                  "update:sortBy": function ($event) {
                    return _vm.$set(_vm.sorting, "sortBy", $event)
                  },
                  "update:sort-by": function ($event) {
                    return _vm.$set(_vm.sorting, "sortBy", $event)
                  },
                  "update:sortDesc": function ($event) {
                    return _vm.$set(_vm.sorting, "sortDesc", $event)
                  },
                  "update:sort-desc": function ($event) {
                    return _vm.$set(_vm.sorting, "sortDesc", $event)
                  },
                  "sort-changed": _vm.getData,
                },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "cell(storeName)",
                      fn: function (row) {
                        return [_vm._v(" " + _vm._s(row.item.storeName) + " ")]
                      },
                    },
                    {
                      key: "cell(pendingCount)",
                      fn: function (row) {
                        return [
                          _c("e-router-link", {
                            attrs: {
                              title: _vm.$t(
                                "Ver notas fiscais recebidas pendentes da loja"
                              ),
                              to: {
                                name: "invoice-received-list",
                                query: {
                                  storeId: String(row.item.storeId),
                                  status: "Pending",
                                  model: "NFE",
                                  applySalableCfops: "true",
                                },
                              },
                              value: "" + row.item.pendingCount,
                            },
                          }),
                        ]
                      },
                    },
                    {
                      key: "cell(totalValue)",
                      fn: function (row) {
                        return [
                          _vm._v(
                            " " +
                              _vm._s(_vm._f("currency")(row.item.totalValue)) +
                              " "
                          ),
                        ]
                      },
                    },
                    {
                      key: "custom-foot",
                      fn: function () {
                        return [
                          _vm.paging.rowCount > 0
                            ? _c("tr", [
                                _c("th", { staticClass: "text-right" }, [
                                  _vm._v(" " + _vm._s(_vm.$t("Total")) + " "),
                                ]),
                                _c("th", { staticClass: "text-center" }, [
                                  _vm._v(
                                    " " + _vm._s(_vm.totalPendingCount) + " "
                                  ),
                                ]),
                                _c("th", { staticClass: "text-right" }, [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm._f("currency")(
                                          _vm.totalPendingValue
                                        )
                                      ) +
                                      " "
                                  ),
                                ]),
                              ])
                            : _vm._e(),
                        ]
                      },
                      proxy: true,
                    },
                  ],
                  null,
                  false,
                  1700488839
                ),
              })
            : _vm._e(),
          !_vm.hasError
            ? _c(
                "b-row",
                [
                  _c(
                    "b-col",
                    [
                      _c("e-pagination-summary", {
                        attrs: {
                          "current-page": _vm.paging.currentPage,
                          "per-page": _vm.paging.pageSize,
                          total: _vm.paging.rowCount,
                          "total-on-page": _vm.paging.rowsInCurrentPage,
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "b-col",
                    [
                      _c("b-pagination", {
                        attrs: {
                          align: "right",
                          "total-rows": _vm.paging.rowCount,
                          "per-page": _vm.paging.pageSize,
                          "aria-controls": "pending-received-invoices-table",
                        },
                        on: { change: _vm.pageChange },
                        model: {
                          value: _vm.paging.currentPage,
                          callback: function ($$v) {
                            _vm.$set(_vm.paging, "currentPage", $$v)
                          },
                          expression: "paging.currentPage",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }